export enum eSessionStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    LOCK = 'locked',
}